/* ============================================================================
   section-bd-combo.js — «Which color are you?» section behavior.
   Wires the chips to the global BiiniiTheme engine (biinii-color-theme.js),
   fills the daily-combo ticket, handles re-roll, and updates the echo line.
   Progressive enhancement: without JS the chips are inert, the ticket shows
   "—", and the page stays on Biinii brand colors. Nothing breaks.
   ============================================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function init(root) {
    if (!root || root.dataset.bdComboReady) return;
    var Theme = window.BiiniiTheme;
    if (!Theme) return; // engine not loaded yet; retry on event below
    root.dataset.bdComboReady = '1';

    var chips = [].slice.call(root.querySelectorAll('.bd-combo__chip'));
    var echo = root.querySelector('.bd-combo__echo');

    // key -> localized label, from the chips (i18n-friendly: uses block labels)
    var names = {};
    chips.forEach(function (c) { names[c.dataset.bdThemeKey] = c.dataset.bdName; });

    function setEcho(kind, key) {
      if (!echo) return;
      var tpl = echo.getAttribute('data-echo-' + kind) || '';
      echo.textContent = key ? tpl.replace('{name}', names[key] || key) : tpl;
    }

    function syncChips(activeKey) {
      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', String(c.dataset.bdThemeKey === activeKey));
      });
    }

    // Chip click = toggle theme (second click on active key = back to brand).
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var key = chip.dataset.bdThemeKey;
        var wasActive = Theme.current() === key;
        Theme.toggle(key);
        setEcho(wasActive ? 'reset' : 'choice', wasActive ? null : key);
      });
    });

    // Keep chips + echo in sync if the theme changes anywhere (e.g. restored).
    document.addEventListener('biinii:theme', function (e) {
      syncChips(e.detail && e.detail.key);
    });

    // Initial state: reflect a theme already restored by the engine on load.
    var current = Theme.current();
    if (current) { syncChips(current); setEcho('stored', current); }

    // ── Daily combo ticket ──────────────────────────────────────────────
    var noEl   = root.querySelector('[data-bd-combo-no]');
    var lidEl  = root.querySelector('[data-bd-combo-lid]');
    var bodyEl = root.querySelector('[data-bd-combo-body]');
    var capEl  = root.querySelector('[data-bd-combo-cap]');
    var COLORS = Theme.COLORS;

    function paintCombo(combo) {
      if (noEl)   noEl.textContent = combo.no;
      if (lidEl)  lidEl.textContent = names[combo.lid] || COLORS[combo.lid].n;
      if (bodyEl) bodyEl.textContent = names[combo.body] || COLORS[combo.body].n;
      if (capEl) {
        capEl.style.background =
          'linear-gradient(90deg, ' + COLORS[combo.lid].hex + ' 50%, ' + COLORS[combo.body].hex + ' 50%)';
      }
    }

    paintCombo(Theme.comboOfDay());

    // Re-roll: jump to another combo on the ticket only (theme untouched).
    // Forward walk by a 7-step stride so lid AND body both change each click.
    var again = root.querySelector('[data-bd-combo-again]');
    if (again) {
      var idx = Theme.comboOfDay().index; // 0..48
      again.addEventListener('click', function () {
        idx = (idx + 8) % 49; // +8 = +1 lid, +1 body → visibly different combo
        var KEYS = Theme.KEYS;
        paintCombo({ no: idx + 1, lid: KEYS[idx % 7], body: KEYS[Math.floor(idx / 7)] });
      });
    }
  }

  function boot() {
    document.querySelectorAll('.bd-combo').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Engine may load after this script; re-attempt when it announces itself.
  document.addEventListener('biinii:theme', boot);
  document.addEventListener('shopify:section:load', boot);
})();
